import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProcedureValidationDTO, ProcedureValidationQuestionDTO } from 'src/app/shared/models/iCourrier/procedure-validation/procedure-validation';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProceduresValidationService {
  public apiBaseUrl: string;

  constructor(private http: HttpClient) {
    const config = environment;
    this.apiBaseUrl = config.apiICourrierBaseUrl;
  }

  getQuestions(procedureValidationID: number): Observable<ProcedureValidationQuestionDTO[]> {
    return this.http.get<ProcedureValidationQuestionDTO[]>(
      `${this.apiBaseUrl}/Global/Documents/ProcedureValidations/${procedureValidationID}/Questions`
    );
  }

  getProcedureValidationById(procedureValidationID: number): Observable<ProcedureValidationDTO[]> {
    return this.http.get<ProcedureValidationDTO[]>(`${this.apiBaseUrl}/Global/Documents/ProcedureValidations?id=${procedureValidationID}`);
  }
}
